const REDIRECT_SOURCE_KEY = 'websky_last_redirect_source';
const AVIASALES_REDIRECT_ID_KEY = 'websky_last_aviasales_redirect_id';
const REDIRECT_EXPIRED_KEY = 'websky_last_redirect_expired';

const getAffiliateData = () => {
	const lastRedirectSource = localStorage.getItem(REDIRECT_SOURCE_KEY),
		lastAviasalesRedirectId = localStorage.getItem(AVIASALES_REDIRECT_ID_KEY),
		redirectExpired = parseInt(localStorage.getItem(REDIRECT_EXPIRED_KEY));

	if (isNaN(redirectExpired) || !lastAviasalesRedirectId || !lastRedirectSource) {
		return null;
	}

	if (redirectExpired >= Date.now()) {
		return {
			redirectSource: lastRedirectSource,
			redirectId: lastAviasalesRedirectId
		};
	}

	return null;
};

export default getAffiliateData;
